module.exports = new (require('fragment-cache'))();



//////////////////
// WEBPACK FOOTER
// ./~/nanomatch/lib/cache.js
// module id = 1893
// module chunks = 0